import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLoginRequest = req.url.includes('/auth/login');
  const isTenantApiKeyRequest = req.headers.has('X-Api-Key');

  if (isLoginRequest) {
    return next(req);
  }

  const isPublicPaymentRequest = req.url.includes('public/payment-links')
    || req.url.includes('/checkout/');
  const token = authService.getToken();

  if (token && !isPublicPaymentRequest) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError(error => {
      // Si es una llamada simulada de tenant con API Key, no cerrar sesión global del admin
      if (error?.status === 401 && !isTenantApiKeyRequest) {
        const path = router.url.split('?')[0];
        const isPublicPaymentPage = path === '/payment-confirmation'
          || path.startsWith('/payment-link')
          || path.startsWith('/checkout');
        authService.logout(!(isPublicPaymentPage || isPublicPaymentRequest));
      }
      return throwError(() => error);
    })
  );
};

